const _temp0 = require("../../intl/overlays/ar-AE.json");
const _temp1 = require("../../intl/overlays/bg-BG.json");
const _temp2 = require("../../intl/overlays/cs-CZ.json");
const _temp3 = require("../../intl/overlays/da-DK.json");
const _temp4 = require("../../intl/overlays/de-DE.json");
const _temp5 = require("../../intl/overlays/el-GR.json");
const _temp6 = require("../../intl/overlays/en-US.json");
const _temp7 = require("../../intl/overlays/es-ES.json");
const _temp8 = require("../../intl/overlays/et-EE.json");
const _temp9 = require("../../intl/overlays/fi-FI.json");
const _temp10 = require("../../intl/overlays/fr-FR.json");
const _temp11 = require("../../intl/overlays/he-IL.json");
const _temp12 = require("../../intl/overlays/hr-HR.json");
const _temp13 = require("../../intl/overlays/hu-HU.json");
const _temp14 = require("../../intl/overlays/it-IT.json");
const _temp15 = require("../../intl/overlays/ja-JP.json");
const _temp16 = require("../../intl/overlays/ko-KR.json");
const _temp17 = require("../../intl/overlays/lt-LT.json");
const _temp18 = require("../../intl/overlays/lv-LV.json");
const _temp19 = require("../../intl/overlays/nb-NO.json");
const _temp20 = require("../../intl/overlays/nl-NL.json");
const _temp21 = require("../../intl/overlays/pl-PL.json");
const _temp22 = require("../../intl/overlays/pt-BR.json");
const _temp23 = require("../../intl/overlays/pt-PT.json");
const _temp24 = require("../../intl/overlays/ro-RO.json");
const _temp25 = require("../../intl/overlays/ru-RU.json");
const _temp26 = require("../../intl/overlays/sk-SK.json");
const _temp27 = require("../../intl/overlays/sl-SI.json");
const _temp28 = require("../../intl/overlays/sr-SP.json");
const _temp29 = require("../../intl/overlays/sv-SE.json");
const _temp30 = require("../../intl/overlays/tr-TR.json");
const _temp31 = require("../../intl/overlays/uk-UA.json");
const _temp32 = require("../../intl/overlays/zh-CN.json");
const _temp33 = require("../../intl/overlays/zh-TW.json");
module.exports = {
  "ar-AE": _temp0,
  "bg-BG": _temp1,
  "cs-CZ": _temp2,
  "da-DK": _temp3,
  "de-DE": _temp4,
  "el-GR": _temp5,
  "en-US": _temp6,
  "es-ES": _temp7,
  "et-EE": _temp8,
  "fi-FI": _temp9,
  "fr-FR": _temp10,
  "he-IL": _temp11,
  "hr-HR": _temp12,
  "hu-HU": _temp13,
  "it-IT": _temp14,
  "ja-JP": _temp15,
  "ko-KR": _temp16,
  "lt-LT": _temp17,
  "lv-LV": _temp18,
  "nb-NO": _temp19,
  "nl-NL": _temp20,
  "pl-PL": _temp21,
  "pt-BR": _temp22,
  "pt-PT": _temp23,
  "ro-RO": _temp24,
  "ru-RU": _temp25,
  "sk-SK": _temp26,
  "sl-SI": _temp27,
  "sr-SP": _temp28,
  "sv-SE": _temp29,
  "tr-TR": _temp30,
  "uk-UA": _temp31,
  "zh-CN": _temp32,
  "zh-TW": _temp33
}